import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** Uses the accent color instead of the current text color. */
  accent?: boolean;
  /** Accessible status text. Omit when the surrounding element already communicates busy state. */
  label?: string;
}

export function Spinner({ size = 'md', accent = false, label }: SpinnerProps) {
  const spinner = (
    <span
      className={[styles.spinner, styles[size], accent && styles.accent].filter(Boolean).join(' ')}
      aria-hidden="true"
    />
  );
  if (!label) return spinner;
  return (
    <span role="status" className={styles.wrapper}>
      {spinner}
      <span className={styles.label}>{label}</span>
    </span>
  );
}
